import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Spinner } from "@components/ui/spinner";
import { Button } from "@components/ui/button";
import { generatePath, Link } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { Organization } from "@/types/Organization";
import { ArrowRightIcon, MessagesSquareIcon } from "lucide-react";
import { useIntercom } from "@/hooks/useIntercom";

export default function MentionsViewEmpty({
  orgUuid,
}: {
  orgUuid: Organization["uuid"];
}) {
  const intercom = useIntercom();

  return (
    <Empty data-testid="empty-search-message">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Spinner />
        </EmptyMedia>
        <EmptyTitle>
          <Trans>Vi lyssnar fortfarande</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>
            Nya bevakningar kan ta lite tid på sig att hitta sina första
            omnämnanden. Kontrollera dina inställningar för att få mejl direkt
            när de dyker upp.
          </Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          render={
            <Link
              to={generatePath(ROUTES.SETTINGS_EMAIL_ORGID, {
                orgUuid,
              })}
            />
          }
          nativeButton={false}
        >
          <Trans>Justera inställningar</Trans>
          <ArrowRightIcon />
        </Button>
        {intercom.show && (
          <Button
            variant="ghost"
            type="button"
            onClick={() => {
              intercom.show();
            }}
          >
            <Trans>Kontakta oss</Trans>
            <MessagesSquareIcon />
          </Button>
        )}
      </EmptyContent>
    </Empty>
  );
}
